import { createRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { queryClient } from "./query-client";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  basepath: import.meta.env.BASE_URL,
  defaultPreload: "intent",
  // Let route loaders reuse the query cache: a hovered link's data is fetched
  // once and considered fresh for a few seconds, so the click is instant.
  defaultPreloadStaleTime: 10_000,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
